import React from 'react';

interface TextAreaProps {
  id: string;
  placeholder?: string;
  value: string;
  setValue?: React.Dispatch<React.SetStateAction<string>>;
  disabled?: boolean;
  max?: string | number;
  name?: string;
  rows?: number;
}

const TextArea = ({
  id,
  placeholder = '',
  value,
  setValue = () => {},
  disabled = false,
  max,
  name,
  rows = 4,
}: TextAreaProps) => {
  return (
    <textarea
      name={name || id}
      id={id}
      placeholder={placeholder}
      className="px-3 py-2 w-full block rounded-md border border-[#E8E8E8] focus:outline-none focus:ring-1 focus:ring-0 focus:ring-offset-0 sm:text-sm placeholder-gray disabled:bg-gray-100"
      value={value}
      onChange={(e) => setValue(e.target.value)}
      disabled={disabled}
      rows={rows}
      {...(max ? { max } : {})}
    />
  );
};

export default TextArea;
